// All site content for the Puttraj public-service website.

export const PHOTOS = {
  portrait: "/photos/portrait.jpg",
  car: "/photos/car.jpg",
  chair: "/photos/chair.jpg",
  walk: "/photos/walk.jpg",
  dks: "/photos/dks.jpg",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Journey", href: "#journey" },
  { label: "Vision", href: "#vision" },
  { label: "Public Service", href: "#service" },
  { label: "Articles", href: "/articles" },
  { label: "Updates", href: "#updates" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const JOURNEY = [
  { no: "01", tag: "Real Estate", title: "Where it all began",
    body: "The early years were spent in real estate — building homes, planning layouts and learning what it really takes to shape a neighbourhood. It taught him that good development is about people first, and bricks second." },
  { no: "02", tag: "Media", title: "Learning to listen, at scale",
    body: "Working in the news industry showed him how much words matter. It shaped a lasting belief in honest communication and keeping people informed with care and responsibility." },
  { no: "03", tag: "Film & Entertainment", title: "The power of a good story",
    body: "As a film producer, he saw how a single story can bring people together. That same instinct — to connect, to move, to celebrate — carries into everything he does." },
  { no: "04", tag: "Community", title: "Coming back to people",
    body: "Every step led here: to communities, to conversations, and to small efforts around education and social development that quietly make a difference." },
];

export const PRIORITIES = [
  { title: "Education", head: "Every child deserves a great start", icon: "GraduationCap",
    body: "When a child can dream freely, everything else becomes possible. Learning should build confidence — not just marks." },
  { title: "Jobs & Enterprise", head: "Room to grow, close to home", icon: "Briefcase",
    body: "Young people shouldn't have to leave to find opportunity. With the right support, careers and small businesses can thrive right here." },
  { title: "Healthcare", head: "Healthy families, stronger communities", icon: "HeartPulse",
    body: "Good health shouldn't depend on how much you earn. Care that's within reach makes life better for everyone." },
  { title: "Infrastructure", head: "Places worth calling home", icon: "Building2",
    body: "Safer roads, cleaner streets and reliable basics — the everyday things that give people dignity and pride in where they live." },
  { title: "Smarter Governance", head: "Government that actually listens", icon: "Landmark",
    body: "Technology can make public services simpler and quicker — and help institutions stay honest and close to the people they serve." },
  { title: "Sustainable Growth", head: "Progress that protects tomorrow", icon: "Leaf",
    body: "We can build for today without borrowing from our children's future. Growth and care for the land can go hand in hand." },
];

export const SERVICE_CARDS = [
  { title: "Community", icon: "Users", body: "Something happening in your area? Tell us — local voices matter most." },
  { title: "Education", icon: "BookOpen", body: "Concerns about schools, colleges or youth opportunities? We're listening." },
  { title: "Public Services", icon: "Building2", body: "Ideas or issues about civic services and infrastructure? Share them here." },
  { title: "Support", icon: "LifeBuoy", body: "Need to reach out for help or guidance? Send a message anytime." },
];

export const CATEGORIES = [
  "Community Issue", "Education", "Employment", "Infrastructure",
  "Healthcare", "Public Service", "Suggestion", "Other",
];

export const UPDATES = [
  { cat: "Community", title: "Sitting down with the people of Bengaluru",
    date: "15 July 2026", loc: "Bengaluru, Karnataka",
    body: "The best conversations happen when you simply show up and listen. Recently, Puttraj spent time with residents, senior citizens and young people — hearing their worries, their hopes and their ideas for the road ahead.",
    quote: "The best solutions always begin with listening." },
  { cat: "Youth", title: "An afternoon with the next generation",
    date: "07 August 2025", loc: "Karnataka",
    body: "A candid session with students and young professionals on learning, starting up, and finding the confidence to lead." },
  { cat: "Media", title: "On the value of honest dialogue",
    date: "03 July 2025", loc: "Bengaluru",
    body: "A conversation with the media on why credible journalism and open, transparent communication matter now more than ever." },
  { cat: "Enterprise", title: "Talking growth with local business",
    date: "28 March 2025", loc: "Bengaluru",
    body: "Sat down with entrepreneurs and business owners to talk about jobs, new ideas and building an economy that lasts." },
  { cat: "Culture", title: "Celebrating what makes Karnataka, Karnataka",
    date: "21 June 2024", loc: "Karnataka",
    body: "Joined neighbours and families in celebrating the traditions, diversity and shared spirit that hold our communities together." },
  { cat: "Development", title: "Out in the field, checking on progress",
    date: "18 June 2024", loc: "Karnataka",
    body: "Visited local development work focused on better infrastructure, a cleaner environment and healthier neighbourhoods." },
];

export const LEADERSHIP = [
  { title: "Building communities", body: "Homes and neighbourhoods that give families something to be proud of." },
  { title: "Keeping people informed", body: "A belief in honest communication and information you can actually trust." },
  { title: "Telling stories that matter", body: "Films and content that bring people together and celebrate who we are." },
  { title: "Showing up for people", body: "Being present, listening closely, and helping where it's genuinely needed." },
  { title: "Building for tomorrow", body: "Backing education and opportunity so the next generation can go further." },
  { title: "Listening. Learning. Leading.", body: "Because good leadership always starts by understanding people first." },
];

export const IMPACT = [
  { title: "Stronger communities", body: "Backing the small efforts that make everyday life a little better for everyone." },
  { title: "Opportunity for youth", body: "Encouraging learning, new ideas and the skills that open real doors." },
  { title: "Giving back", body: "Standing with people through community welfare and responsible growth." },
  { title: "Staying connected", body: "Keeping the door open, and the conversation with people always going." },
];

export const GALLERY = [
  { src: PHOTOS.portrait, cat: "Public Engagement", label: "At the Vidhana Soudha" },
  { src: PHOTOS.dks, cat: "Community", label: "With senior leadership" },
  { src: PHOTOS.walk, cat: "Events", label: "Meeting people" },
  { src: PHOTOS.chair, cat: "Media", label: "A quiet moment" },
  { src: PHOTOS.car, cat: "Development", label: "On the move" },
];
export const GALLERY_CATS = ["All", "Community", "Public Engagement", "Events", "Media", "Development"];

export const CONFIG = {
  whatsapp: process.env.REACT_APP_WHATSAPP_NUMBER || "919900509090",
  maps: process.env.REACT_APP_MAPS_LINK || "https://maps.app.goo.gl/TeweM8iz8D8s3aiD7?g_st=aw",
  email: process.env.REACT_APP_OWNER_EMAIL || "Rajj.cmd@gmail.com",
  instagram: "https://www.instagram.com/myselfputtraj",
  facebook: "https://www.facebook.com/share/1BtFmbbUgK/",
  waMessage: "Hello Puttraj Team, I would like to share a concern/query regarding my constituency.",
};

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};
